import { api } from '@api'
import { Scope } from '@utils'
import type { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type Birthday = {
  id: string
  avatarUrl?: string | null
  fullName: string
  birthDate: string
  hashtags: string[]
  scope: string
  isGhost?: boolean
  createdAt: string
  updatedAt: string
}

interface GetBirthdaysParams {
  birthday?: string // ISO date string (YYYY-MM-DD)
  scope?: Scope
  search?: string
  limit?: number
}

const fetchBirthdays = async (
  params?: FetchParams & GetBirthdaysParams,
): Promise<PaginatedResponse<Birthday>> => {
  const queryParams = new URLSearchParams()
  if (params?.birthday) {
    queryParams.append('birthday', params.birthday)
  }
  if (params?.scope) {
    queryParams.append('scope', params.scope)
  }
  if (params?.search) {
    queryParams.append('search', params.search)
  }
  if (params?.pageParam) {
    queryParams.append('page', String(params.pageParam))
  }
  if (params?.limit) {
    queryParams.append('limit', String(params.limit))
  }
  
  const url = `/birthdays${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
  const { data } = await api.get<PaginatedResponse<Birthday>>(url)
  return data
}

export const usePaginateBirthdays = (params?: GetBirthdaysParams) => {
  return usePaginate<Birthday>('birthdays', fetchBirthdays, params)
}

